module.exports = __webpack_public_path__ + "static/media/mad-science.tar.e85e9705.gz";